import { render } from "./MenuMegaImage.vue?vue&type=template&id=5f9860df"
import script from "./MenuMegaImage.vue?vue&type=script&lang=js"
export * from "./MenuMegaImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__